import BaseApi from '@/api/BaseApi';
import type { IPaginate } from '@/models/TableSettingsModel';
import type {
    ICreateEditQuizRequest,
    ICreateEditQuizResponse,
    IQuizAnswersSummaryResponse,
    IQuizDetailsQuestionsResponse,
    IQuizDetailsResponse,
    IQuizResponse,
    ISummaryQuizRequest
} from '@/models/QuizModel';

export default class QuizApi extends BaseApi {
	async deleteQuiz (quizId: number) {
		return this.delete({
			url: `/api/quiz/${quizId}`,
		});
	};

	async createQuiz (payload: ICreateEditQuizRequest) {
        const formData = new FormData();
        formData.append('name', payload.name || '');
        formData.append('lead', payload.lead || '');
        formData.append('text', payload.text || '');
        formData.append('video_url', payload.video_url || '');
        formData.append('image', payload.image);
        formData.append('questions', JSON.stringify(payload.questions));
		return this.post<ICreateEditQuizRequest, ICreateEditQuizResponse>({
			url: `/api/quiz`,
            data: payload,
            config: {
                contentType: 'multipart/form-data',
            },
		});
	};

	async editQuiz (payload: ICreateEditQuizRequest, quizId: string | string[]) {
        const formData = new FormData();
        formData.append('name', payload.name || '');
        formData.append('lead', payload.lead || '');
        formData.append('text', payload.text || '');
        formData.append('video_url', payload.video_url || '');
        formData.append('image', payload.image);
        formData.append('questions', JSON.stringify(payload.questions));
		return this.post<ICreateEditQuizRequest, ICreateEditQuizResponse>({
			url: `/api/quiz/${quizId}/packed-update`,
            data: payload,
            config: {
                contentType: 'multipart/form-data',
            },
		});
	};

	async saveQuizSummary (payload: ISummaryQuizRequest, quizId: string | string[]) {
        const formData = new FormData();
        formData.append('name', payload.name || '');
        formData.append('lead', payload.lead || '');
        formData.append('text', payload.text || '');
        if (payload.video_url != null) {
            formData.append('video_url', payload.video_url || '');
        }
        if (payload.image != null) {
            formData.append('image', payload.image);
        }
        formData.append('date_from', payload.date_from);
        formData.append('date_to', payload.date_to);
        formData.append('is_one_time', payload.is_one_time);
        formData.append('price', payload.price);
        formData.append('is_survey', payload.is_survey);
        formData.append('correct_answers', payload.correct_answers);
		return this.post<ISummaryQuizRequest, any>({
			url: `/api/quiz/${quizId}/submit-details`,
            data: payload,
            config: {
                contentType: 'multipart/form-data',
            },
		});
	};

	async quizDetails (quizId: string | string[]) {
		return this.get<IQuizDetailsResponse>({
			url: `/api/quiz/${quizId}`,
		});
	};

    async quizList (page: number, perPage: number, sortBy: string | null, sortDesc: string | null, search: string | null) {
        let url = `/api/quiz?page=${page}&per_page=${perPage}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        if (null != search) {
            url += `&search=${search}`;
        }

        return this.get<IPaginate<IQuizResponse>>({
            url: url,
        });
    };

    async saveQuizAnswers (quizId: string | string[], payload: IQuizDetailsQuestionsResponse[]) {
        return this.post<IQuizDetailsQuestionsResponse[], IQuizAnswersSummaryResponse>({
            url: `/api/quiz/${quizId}/submit`,
            data: payload,
        });
    };
};
